<div class="main" (click)="menuService.hide()">
  <div class="container">
    <div id="change-pass" class="tab-pane in active">
      <form class="info-form" [formGroup]="editForm" style="min-width: 350px;">
          <div class="row">
            <div class="form-group col-12">
              <label class="font-bold">{{'Mật khẩu cũ' | translate}}
                <span class="required">*</span>
              </label>
              <input type="password" class="form-control" name="currentPass" formControlName="currentPassword">
              <app-error-text
              [isDisplay]="isSaved && editForm.get('currentPassword')?.errors?.required"
                  [message]="('Mật khẩu cũ' | translate) + (' bắt buộc nhập' | translate)">
              </app-error-text>
            </div>
            <div class="form-group col-12">
              <label class="font-bold">{{'Mật khẩu mới' | translate}}
                <span class="required">*</span>
              </label>
              <input type="password"  autocomplete="off" class="form-control" name="pass" formControlName="newPassword">
              <app-error-text
              [isDisplay]="isSaved && editForm.get('newPassword')?.errors?.required"
                  [message]="('Mật khẩu mới' | translate) + (' bắt buộc nhập' | translate)">
              </app-error-text>
              <!-- <app-error-text [isDisplay]="isSaved && !editForm.get('newPassword')?.errors?.required && errors.invalidPassword"
                  [message]="('Mật khẩu mới' | translate) + (' không hợp lệ' | translate)">
              </app-error-text> -->
              <app-error-text [isDisplay]="isSaved && !editForm.get('password')?.errors?.required && !isHas8Length"
                  [message]="('Mật khẩu' | translate) + (' tối thiểu là 8 ký tự' | translate)">
              </app-error-text>
            </div>
            <div class="form-group col-12">
              <label class="font-bold">{{'Nhập lại mật khẩu mới' | translate}}
                <span class="required">*</span>
              </label>
              <input type="password"  autocomplete="off" class="form-control" name="confirmPass" formControlName="confirmPassword">
              <app-error-text
                  [isDisplay]="isSaved && editForm.get('confirmPassword')?.errors?.required"
                  [message]="('Nhập lại mật khẩu' | translate) + (' bắt buộc nhập' | translate) | translate">
              </app-error-text>
              <app-error-text
                  [isDisplay]="isSaved && editForm.get('newPassword').value !== editForm.get('confirmPassword').value"
                  [message]="'Mật khẩu nhập lại không trùng khớp.' | translate">
              </app-error-text>
            </div>
            <!-- <div class="form-group col-12">
              <span>Mật khẩu bao gồm:</span>
              <ul>
                  <li [ngClass]="!isSaved ? '' : isHas8Length ? 'right-patter-password' : 'wrong-patter-password'">
                      Chiều dài tối thiểu là 8</li>
                  <li [ngClass]="!isSaved ? '' : isHasLetter ? 'right-patter-password' : 'wrong-patter-password'">
                      Bao gồm chữ thường (a-z) và chữ in hoa (A-Z)</li>
                  <li [ngClass]="!isSaved ? '' : isHasNonLetter ? 'right-patter-password' : 'wrong-patter-password'">
                      Chứa ít nhất một số (0-9) hoặc ký hiệu đặc biệt</li>
              </ul>
            </div> -->
            <div class="d-flex w-100 justify-content-center">
              <button type="submit" (click)="save()"
              class="btn btn-save btn--blue btn-block">{{'Thay đổi' | translate}}</button>
            </div>
          </div>
      </form>
    </div>
  </div>
</div>
